// Copyright (c) 2026 WiseTime. All rights reserved.

import { RouteProps } from "react-router"
import { t } from "@lingui/macro"
import { activateI18n } from "locales/i18nUtil"

activateI18n()

export const autoNarrativeHelpUrl = "https://help.wisetime.com/hc/en-us/articles/15961800034839"

export const BASE_PATH = "timeline"

export const TIMELINE_BASE_PATH = "/day/"
export const TRASH_BASE_PATH = "/trash/"

export const ROUTE_PATH = {
  TIMELINE: {
    path: `${TIMELINE_BASE_PATH}:date?`,
    title: t({ id: "label_my_timeline", message: "My Timeline" }),
  },
  TRASH: {
    path: `${TRASH_BASE_PATH}:month?`,
    title: t({ id: "label_trash", message: "Trash" }),
  },
  NARRATE_PREFERENCES: {
    path: "/ai-narrative-preferences",
    title: t({ id: "label_ai_narrative_preferences", message: "AI Narrative Preferences" }),
  },
  TIMESHEET_FIELDS: {
    path: "/timesheet-fields",
    title: t({ id: "label_timesheet_fields", message: "Timesheet Fields" }),
  },
  FLAGS: {
    path: "/flags",
    title: "Flags",
  },
}

export type RouteDefinition = {
  title: string,
  main?: React.ComponentType<Record<string, never>>,
  sidebar?: React.ComponentType<Record<string, never>>,
} & RouteProps
